import { Box, Grid } from '@mui/material';

import { Typography, LazyAutocompleteFieldNotMultiple } from '@occc/ui-design-system';

import {
  mapSubBrandsQueryResponseToRawArray,
  mapRawSubBrandsResponseItemToAutocompleteOption,
  useSubBrandsQuery,
} from './sub-brand-constraint.utils';
import { SubBrand } from './sub-brand-constraint.types';

export const SubBrandConstraint = () => {
  return (
    <Box>
      <Typography variant='h6' paragraph>
        Sub Brand
      </Typography>
      <Grid container>
        <Grid item xs={12} md={3}>
          <LazyAutocompleteFieldNotMultiple<SubBrand, SubBrand[]>
            name='subBrandConstraint.subBrand'
            label='Sub Brand'
            useLazyQuery={useSubBrandsQuery}
            mapQueryResponseToRawArray={mapSubBrandsQueryResponseToRawArray}
            mapRawResponseItemToAutocompleteOption={mapRawSubBrandsResponseItemToAutocompleteOption}
            inputProps={{ margin: 'none' }}
            first={100}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
